import React from 'react'
import Radio from '@components/Radio'
import { FormattedMessage } from 'react-intl'

interface IShowHoursButton {
  showAll: boolean
  setShowAll: (showAll: boolean) => void
  customLabel?: string
}

const ShowHoursButton: React.FC<IShowHoursButton> = ({
  showAll = false,
  setShowAll = () => {},
  customLabel = 'Show booked hours',
}) => {
  return (
    <Radio.Group flow name="" onChange={() => setShowAll(!showAll)} value={`${showAll}`}>
      <Radio.Button key="false" id="false" value="false">
        <FormattedMessage id={customLabel} defaultMessage={customLabel} />
      </Radio.Button>
      <Radio.Button key="true" id="true" value="true">
        <FormattedMessage id="Show all hours" />
      </Radio.Button>
    </Radio.Group>
  )
}

export default ShowHoursButton
